import { Styles, css } from '@styled-system/css';
import { stack } from '@styled-system/patterns';

import type { BillingPeriod } from '@/features/subscription/types';

interface BillingPeriodToggleProps {
  value: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
  discount?: string;
  disabled?: boolean;
}

export const BillingPeriodToggle = ({
  value,
  onChange,
  discount = '-15%',
  disabled = false,
}: BillingPeriodToggleProps) => {
  const containerStyles = stack({
    direction: 'row',
    p: '0.1875rem',
    gap: 'xs',
    borderRadius: 'xl',
    border: '1px solid',
    borderColor: 'base.border',
    overflow: 'hidden',
    fontFamily: 'Manrope, sans-serif',
    ...(disabled && {
      opacity: 0.5,
      pointerEvents: 'none',
    }),
  });

  const buttonBaseStyles: Styles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: '0.94rem',
    py: '0.5rem',
    borderRadius: 'xl',
    fontSize: 'sm',
    fontWeight: 'semibold',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 150ms ease',
    border: 'none',
    outline: 'none',
    background: 'none',
    flexShrink: 0,
  };

  const activeButtonStyles = css(buttonBaseStyles, {
    backgroundColor: 'accent.primary',
    color: 'font.primary',
  });

  const inactiveButtonStyles = css(buttonBaseStyles, {
    backgroundColor: 'transparent',
    color: 'font.secondary',
    '&:hover': {
      color: 'font.primary',
    },
  });

  return (
    <div className={containerStyles}>
      <button
        type="button"
        className={value === 'monthly' ? activeButtonStyles : inactiveButtonStyles}
        onClick={() => !disabled && onChange('monthly')}
        disabled={disabled}
      >
        Mensuel
      </button>

      <button
        type="button"
        className={value === 'yearly' ? activeButtonStyles : inactiveButtonStyles}
        onClick={() => !disabled && onChange('yearly')}
        disabled={disabled}
      >
        Annuel({discount})
      </button>
    </div>
  );
};
